import { QueryClient } from '@tanstack/react-query'

// Create a custom query client with global error handling
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.status >= 400 && error?.status < 500) {
          return false
        }
        // Retry up to 3 times for other errors
        return failureCount < 3
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
      onError: (error: any) => {
        // Only show error on client side
        if (typeof window !== 'undefined') {
          // Dynamically import to avoid SSR issues
          import('./toast').then(({ showError }) => {
            const errorMessage = error?.message || 'An unexpected error occurred'
            showError(`Operation failed: ${errorMessage}`)
          })
        }
      },
    },
  },
})

// Error boundary for React Query
export class QueryErrorBoundary {
  static handleError(error: Error, errorInfo: any) {
    // Only show error on client side
    if (typeof window !== 'undefined') {
      // Dynamically import to avoid SSR issues
      import('./toast').then(({ showError }) => {
        showError('Something went wrong. Please refresh the page and try again.')
      })
    }
  }
}